import React from 'react';
import PropTypes from 'prop-types';
import currencyFormat from 'utils/currency-format';
import Exchange from 'components/UI/Exchange';
function ComponentSummary({
    total, commission, currency, className, showCommission,
})
{
    const parsedTotal = Number(total);
    return (
        <div className={`tw-grid tw-grid-cols-2 tw-w-full tw-mb-2 ${className || ''}`}>
            <div className="tw-flex-col tw-justify-center tw-text-white tw-rounded-md tw-text-center tw-flex tw-items-center tw-p-2 tw-mr-1 max-sm:tw-col-span-2 tw-bg-neutral-700">
                <span>Total: </span>
                <Exchange
                    price={parsedTotal}
                    currency={currency}
                />
            </div>
            {showCommission
            && (
                <div className="tw-flex-col tw-justify-center tw-bg-primary-default tw-rounded-md tw-text-white tw-flex tw-ml-1 max-sm:tw-mt-1 tw-text-center tw-p-2 max-sm:tw-col-span-2">
                    <span>Total Commission:</span>
                    <span>{currencyFormat(commission)}</span>
                </div>
            )}
        </div>
    );
}

ComponentSummary.defaultProps = {
    showCommission: true,
};

ComponentSummary.propTypes = {
    className: PropTypes.string,
    showCommission: PropTypes.bool,
    total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    commission: PropTypes.number.isRequired,
    currency: PropTypes.shape({
        currency_change: PropTypes.number,
        code: PropTypes.string,
    }),
};
export default ComponentSummary;
